// Images for the MATIKKA VALMIS landing (WebP in Impultienda Recursos, store 8b8fa9d9-...).
// Finnish mockup: 6 osaa, transparent, 2048 px.
export const PRODUCT_IMAGE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/8b8fa9d9-995e-4832-85d2-19be84443c33/1792620041723_matikka-valmis-mockup-6-osaa-transparente-d27e1999.webp';
